/**
 * @cfleet/customer - Application Entry Point
 *
 * Main entry point for the CFleet Customer Portal application.
 * Sets up React with providers for authentication, API, and routing.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Get the root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your index.html'
  );
}

// Create React root and render the app
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
